const ChefIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.68105 2.24489C6.32047 1.41241 7.32662 0.875 8.45841 0.875C10.3914 0.875 11.9584 2.442 11.9584 4.375C11.9584 5.67093 11.254 6.80188 10.2084 7.4067V12.25C10.2084 12.7332 9.81666 13.125 9.33341 13.125H5.25008C4.76683 13.125 4.37508 12.7332 4.37508 12.25V7.27565C3.0626 7.13056 2.04175 6.01783 2.04175 4.66667C2.04175 3.21692 3.217 2.04167 4.66675 2.04167C5.02592 2.04167 5.36875 2.11395 5.68105 2.24489ZM8.45841 1.45833C7.43925 1.45833 6.54198 1.98082 6.02006 2.77392L5.8729 2.99754L5.63751 2.87004C5.34908 2.71382 5.01872 2.625 4.66675 2.625C3.53917 2.625 2.62508 3.53909 2.62508 4.66667C2.62508 5.79425 3.53917 6.70833 4.66675 6.70833H4.95841V12.25C4.95841 12.4111 5.089 12.5417 5.25008 12.5417H9.33341C9.4945 12.5417 9.62508 12.4111 9.62508 12.25V7.05503L9.78399 6.9738C10.7291 6.49067 11.3751 5.50802 11.3751 4.375C11.3751 2.76417 10.0692 1.45833 8.45841 1.45833Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.37508 11.375C4.37508 11.2139 4.50566 11.0833 4.66675 11.0833H7.58341C7.7445 11.0833 7.87508 11.2139 7.87508 11.375C7.87508 11.5361 7.7445 11.6667 7.58341 11.6667H4.66675C4.50566 11.6667 4.37508 11.5361 4.37508 11.375Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.37508 10.2083C4.37508 10.0472 4.50566 9.91667 4.66675 9.91667H6.41675C6.57783 9.91667 6.70841 10.0472 6.70841 10.2083C6.70841 10.3694 6.57783 10.5 6.41675 10.5H4.66675C4.50566 10.5 4.37508 10.3694 4.37508 10.2083Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default ChefIcon
